import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'

export const errorLoggerMiddleware = () => (next) => (action) => {
  if (action.payload instanceof Error) {
    trackWithoutThrow(action.payload)
  }
  next(action)
}
